import { ServerCIEnvironment, type ServerBaseUrl } from '~/servers/types';

/**
 * Server configuration for the local Docker Compose stack (`wise-multi-client:8033`)
 */
export const dockerServerConfig: ServerBaseUrl = {
    apiServer: 'http://wise-api:8002',
    auroraApiServer: 'https://dev.aurora-v2.wisesys.info',
    equipment: 'https://services-stage.us.wisesys.info',
    auroraServer: 'https://dev-api.aurora-v2.wisesys.info',
    socketServer: 'ws://wise-socket:1037',
    equipmentSocketServer: 'wss://equipmentsocket-stage.us.wisesys.info',
    CIEnv: ServerCIEnvironment.DEVELOPMENT,
    vehicleProfile: 'http://vehicle-profiles-api:8020',
    routePathGeometryServer:
        'https://0tc6grz4n9.execute-api.us-east-1.amazonaws.com/development',
    configurableWorkflowServer:
        'https://uu9d8rt95l.execute-api.us-east-1.amazonaws.com/Prod',
    driverCostServer: 'http://localhost:3010',
    bannerService: 'https://tp3ei4l6wg.execute-api.us-east-1.amazonaws.com/dev'
};
